import { useEffect, useState, useMemo } from 'react';

import useUserStore from '@lcsc-ui/store/user';
import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';
import { Input } from 'antd';

const { Search } = Input;

const classMap = {
  hot: 'bg-[#FFEEEE] text-[#F4220F]',
  recommend: 'bg-[#FFEFE6] text-[#FF5901]',
  domestic: 'bg-[#E5EEFF] text-[#0556F5]',
};

const classIconMap = {
  hot: 'w-[14px] h-[18px] bg-[url(https://static.szlcsc.com/ecp/assets/web/layout/catalogs/images/hot.svg)]',
  recommend:
    'w-[16px] h-[16px] bg-[url(https://static.szlcsc.com/ecp/assets/web/layout/catalogs/images/recommend.svg)]',
  domestic: 'w-[29px] h-[16px] bg-[url(https://static.szlcsc.com/ecp/assets/web/layout/catalogs/images/domestic.svg)]',
};
const MroSubCatalogList = ({ catalogListData, catalogCount, resourceData }) => {
  const [data, setData] = useState([]);
  const [searchNameList, setSearchNameList] = useState([]);
  const [count, setCount] = useState(null);
  const [keyWord, setKeyWord] = useState('');
  const { userInfo } = useUserStore();

  const searchNameListHtml = useMemo(() => {
    const htmlData = searchNameList?.map((item, idx) => {
      return (
        <li
          key={idx}
          className="p-[0px_12px_3px_12px] text-[14px] text-[#999] leading-[20px] cursor-pointer hover:text-[#0093E6]"
          onClick={() => handleSelect(item)}
        >
          {item}
        </li>
      );
    });
    return htmlData;
  }, [searchNameList]);

  useEffect(() => {
    setData((catalogListData || []).filter((item) => item.isSearch));
  }, [catalogListData]);

  useEffect(() => {
    setCount(catalogCount?.toLocaleString());
  }, [catalogCount]);

  const thirdListHtmlFn = (sonCatalogList) => {
    const thirdListHtml = sonCatalogList?.map((item, index) => {
      return (
        <>
          {item.isSearch && (
            <li
              key={item.mroCatalogId + index.toString()}
              className="leading-[25px] mr-[15px] text-[#666] text-[12px]"
              data-spm="cat"
            >
              <a href={item.link} data-spm={index + 1} className="flex items-center">
                {item.catalogName}
              </a>
            </li>
          )}
        </>
      );
    });
    return thirdListHtml;
  };

  const sonListHtmlFn = (sonCatalogList) => {
    const sonListHtml = sonCatalogList?.map((item, index) => {
      return (
        <li key={item.mroCatalogId + index.toString()} className="w-[100%]" data-spm="cal">
          {item.isSearch && (
            <div
              className="text-[14px] text-[#333] pl-[20px] rounded-[5px] bg-[#f7fafc] font-semibold
                  h-[35px] w-[100%] leading-[35px] mb-[5px] truncate mt-[14px] flex items-center relative
                  after:w-[3px] after:h-[14px] after:bg-[#0095e8] after:left-[10px] after:top-[11px] after:absolute"
            >
              <a
                href={resourceData?.projectConfigVO?.lcscListUrl + '/mro/sub/catalog/' + item.mroCatalogId + '.html'}
                data-spm={index + 1}
                className="flex items-center"
              >
                {item.catalogName}
                {!!item.groupProductCount && <span>（{item.groupProductCount?.toLocaleString()}）</span>}
                {item.hasCatalogImage && (
                  <img
                    className="w-[15px] h-[13px] ml-[5px]"
                    src="https://static.szlcsc.com/ecp/assets/web/page/www/catalog/images/two-look.png"
                  />
                )}
              </a>
            </div>
          )}
          <ul className="text-[14px] text-[#333] flex flex-wrap items-center tetx-[#666]">
            {thirdListHtmlFn(item.sonCatalogList)}
          </ul>
        </li>
      );
    });
    return sonListHtml;
  };

  const keywordVOListHtmlFn = (keywordVOList) => {
    const keywordVOListHtml = keywordVOList?.map((item, index) => {
      return (
        <li
          key={item.mroCatalogId + index.toString()}
          data-spm="ke"
          className="text-[14px] h-[12px] w-[50%] mt-[12px] flex items-center text-[#0093E6]"
        >
          <a data-spm={index + 1} href={item.keywordUrl} className="truncate" onClick={() => buriedPointFn(item)}>
            {item.keywordName}
          </a>
        </li>
      );
    });
    return keywordVOListHtml;
  };

  const catalogTagVOListHtmlFn = (catalogTagVOList) => {
    const catalogTagVOListHtm = catalogTagVOList?.map((item, index) => {
      return (
        <li
          key={item.catalogTagName + index.toString()}
          className={`relative mt-[17px] w-[100px] h-[25px] mr-[20px]`}
          data-spm="tag"
        >
          <a
            data-spm={index + 1}
            href={item.catalogUrl}
            title={item.catalogTagName}
            onClick={() => catalogPageMarketingBuriedPoint(item)}
            className={`block text-[14px] w-[100px] h-[25px]  px-[5px] leading-[25px] text-center truncate rounded-[3px] ${classMap[item.logName] ? classMap[item.logName] : 'bg-[#E7F6FF] text-[#199FE9]'}`}
          >
            {item.catalogTagName}
          </a>
          {!!item.logName && (
            <i className={`${classIconMap[item.logName]} top-[-10px] right-[-5px] bg-no-repeat absolute`}></i>
          )}
        </li>
      );
    });
    return catalogTagVOListHtm;
  };

  const buriedPointFn = (item) => {
    buriedPoint({
      pf: 'pc',
      ty: 'click',
      cp: 'catalog_page',
      op: 'catalog_page_keyword',
      data: {
        catalog_id: item.catalogid,
        sp: item.keywordName,
        hf: item.keywordUrl,
        user_type: userInfo?.customerLogin,
      },
    });
  };

  const catalogPageMarketingBuriedPoint = (item) => {
    buriedPoint({
      pf: 'pc',
      ty: 'click',
      cp: 'catalog_page',
      op: 'catalog_page_marketing',
      data: {
        catalogTag_id: item.catalogTagId,
        sp: item.catalogTagName,
        hf: item.catalogUrl,
        user_type: userInfo?.customerLogin,
        parent_id: item.parentId,
      },
    });
  };

  const wrapListHtml = data?.map((item, index) => {
    return (
      <li key={item.mroCatalogId + index.toString()} id={item.mroCatalogId + 'catalog'} data-spm="ca">
        <div className="w-[100%] flex items-center h-[40px] leading-[40px] text-[14px] font-semibold border-b-[1px] border-solid border-[#0294e7] cursor-pointer mt-[15px]">
          <a
            href={resourceData?.projectConfigVO?.lcscListUrl + '/mro/sub/catalog/' + item.mroCatalogId + '.html'}
            data-spm={index + 1}
            className="truncate"
          >
            {item.catalogName}
            {!!item.catalogLevelCount && (
              <span className="text-[14px] text-[#999]">（{item.catalogLevelCount?.toLocaleString()}）</span>
            )}
          </a>
          {item?.hasCatalogImage && (
            <a
              data-spm={'p' + index + 1}
              href={resourceData?.projectConfigVO?.lcscListUrl + '/mro/sub/catalog/' + item.mroCatalogId + '.html'}
              onMouseLeave={() => handleEnter(item)}
              onMouseEnter={() => handleLeave(item)}
              className="ml-[10px]"
            >
              <img
                src={
                  item.isActive
                    ? 'https://static.szlcsc.com/ecp/assets/web/page/www/catalog/images/img_con_active.svg'
                    : 'https://static.szlcsc.com/ecp/assets/web/page/www/catalog/images/img_con.svg'
                }
              />
            </a>
          )}
        </div>
        <ul className="flex items-center w-[100%] flex-wrap">
          {sonListHtmlFn(item.sonCatalogList)}
          {keywordVOListHtmlFn(item.keywordVOList)}
        </ul>
        {!!item?.catalogTagVOList?.length && (
          <ul className="flex items-center w-[100%] flex-wrap">{catalogTagVOListHtmlFn(item.catalogTagVOList)}</ul>
        )}
      </li>
    );
  });

  const handleSelect = (name) => {
    setKeyWord(name);
    setSearchNameList([]);
    searchCatalog(true, name, true);
  };

  const handleEnter = (obj) => {
    setData(
      data.map((item) => {
        if (item.mroCatalogId === obj.mroCatalogId) {
          return {
            ...item,
            isActive: false,
          };
        } else {
          return item;
        }
      })
    );
  };

  const handleLeave = (obj) => {
    setData(
      data.map((item) => {
        if (item.mroCatalogId === obj.mroCatalogId) {
          return {
            ...item,
            isActive: true,
          };
        } else {
          return item;
        }
      })
    );
  };

  const searchCatalog = (bol, kw, isClick = false) => {
    const catalogLevelOneOrder = [
      '电容',
      '电阻',
      '连接器',
      '二极管',
      '电源管理',
      '处理器及微控制器',
      '晶体管',
      '开关',
      '光电器件',
      '电感/线圈/变压器',
      '晶体/振荡器/谐振器',
      '数据转换芯片',
      '接口芯片',
      '射频无线电',
      '放大器、线性器件',
      '嵌入式外围芯片',
      '逻辑芯片',
      '开发板/开发工具',
      '存储器',
      '传感器',
      '滤波器/EMI优化',
      '保险丝',
      '显示模块/LED驱动/显示驱动',
      '仪器仪表/工具',
      '继电器',
      '五金/焊材/辅料/电池',
      '功能模块',
      '物联网/通信模块',
      '音频器件/微电机(马达)',
      '劳动保护用品',
      '实用电子电器/书籍',
      '免费赠品区',
    ];
    let catalogCount = 0;
    const list = JSON.parse(JSON.stringify(catalogListData));
    list.forEach((item) => {
      if (!kw) {
        item.isSearch = true;
        item.catalogLevelCount = item.groupProductCount;
        if (item.sonCatalogList && item.sonCatalogList.length > 0) {
          item.sonCatalogList.forEach((sonCatalog) => {
            sonCatalog.isSearch = true;
            // 添加第三层遍历
            if (sonCatalog.sonCatalogList && sonCatalog.sonCatalogList.length > 0) {
              sonCatalog.sonCatalogList.forEach((grandsonCatalog) => {
                grandsonCatalog.isSearch = true;
              });
            }
          });
        }
        setSearchNameList([]);
      } else {
        item.isSearch = item.catalogName.indexOf(kw) !== -1;
        item.catalogLevelCount = 0;
        if (item.sonCatalogList && item.sonCatalogList.length > 0) {
          item.sonCatalogList.forEach((sonCatalog) => {
            sonCatalog.isSearch = sonCatalog.catalogName.indexOf(kw) !== -1;
            item.isSearch = item.isSearch || sonCatalog.isSearch; // 处理没匹配到一级目录但是匹配到二级目录的情况
            item.catalogLevelCount += sonCatalog.isSearch ? Number(sonCatalog.groupProductCount) : 0;
            if (sonCatalog.sonCatalogList && sonCatalog.sonCatalogList.length > 0) {
              sonCatalog.sonCatalogList.forEach((grandsonCatalog) => {
                grandsonCatalog.isSearch = grandsonCatalog.catalogName.indexOf(kw) !== -1;
                item.isSearch = item.isSearch || grandsonCatalog.isSearch; // 处理没匹配到一级目录但是匹配到二级目录的情况
                item.catalogLevelCount += grandsonCatalog.isSearch ? Number(grandsonCatalog.groupProductCount) : 0;
              });
            }
          });
        }
      }
      catalogCount += Number(item.catalogLevelCount);
      if (item.hasCatalogImage) {
        item.hasCatalogImage = JSON.parse(item.hasCatalogImage);
      }
    });
    let result = [];
    catalogLevelOneOrder.forEach((catalogLevelOne) => {
      // 将一级目录按照给定的顺序排序
      const ci = list.findIndex((l) => l.catalogName === catalogLevelOne);
      if (ci !== -1) {
        result.push(list[ci]);
        list.splice(ci, 1);
      }
    });
    if (list.length) {
      result = result.concat(...list);
    }
    const searchNameList = [];
    if (kw) {
      result.forEach((item) => {
        if (item.isSearch) {
          if (item.sonCatalogList && item.sonCatalogList.length > 0) {
            item.sonCatalogList.forEach((data) => {
              if (data.isSearch) {
                searchNameList.push(data.catalogName);
              }
              if (data.sonCatalogList && data.sonCatalogList.length > 0) {
                data.sonCatalogList.forEach((grandsonCatalog) => {
                  if (grandsonCatalog.isSearch) {
                    searchNameList.push(grandsonCatalog.catalogName);
                  }
                });
              }
            });
          }
        }
      });
      setSearchNameList(isClick ? [] : searchNameList);
    }
    if (bol) {
      setData(result.filter((item) => item?.isSearch));
      setCount(catalogCount.toLocaleString());
    }
  };

  const onSearch = (e) => {
    setKeyWord(e);
    searchCatalog(true, e);
  };

  const onPressEnter = (e) => {
    setKeyWord(e.target.value);
    searchCatalog(true, e.target.value);
  };

  const onChange = (e) => {
    setKeyWord(e.target.value);
    searchCatalog(false, e.target.value);
  };

  return (
    <section className="w-[100%] ml-[20px]" data-spm="ls">
      <ul className="flex justify-between mb-[5px] items-center">
        <li className="font-semibold text-[#444] text-[14px] h-[52px] leading-[52px]">
          全部工业品：
          <span className="text-[22px]">{count}</span>
        </li>
        <li className="relative">
          <Search
            placeholder="在结果中搜索"
            onChange={onChange}
            onSearch={onSearch}
            onPressEnter={onPressEnter}
            value={keyWord}
            style={{ width: '258px', height: '40px' }}
          />
          {!!searchNameList.length && (
            <ul className="absolute w-[258px] top-[32px] border-t-0 border-solid border-[1px] border-[#e9e9e9] pt-[12px] bg-[#fff] z-[10]">
              {searchNameListHtml}
            </ul>
          )}
        </li>
      </ul>
      <div>
        <ul className="w-[100%]" id="list-container">
          {wrapListHtml}
        </ul>
      </div>
    </section>
  );
};

export default MroSubCatalogList;
